import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { idiomsData, getDataForDifficulty } from '../courses/data/vocabulary/idioms';

export default function IdiomsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : idiomsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
